"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerOpenFaInLayer = void 0;
const render_1 = require("./render");
const openLayer_1 = require("./openLayer");
const createLogger_1 = require("./validate/createLogger");
const validateAndConvert_1 = require("./validate/validateAndConvert");
const registerOpenFaInLayer = (featureServices, actionId) => {
    const userInteractionService = featureServices['user-interaction-service'];
    const logger = featureServices['s2:logger'];
    const layerManager = featureServices['layer-manager'];
    userInteractionService.register(actionId, {
        action: (params, urlParams) => {
            const log = (0, createLogger_1.createLogger)(logger, actionId);
            const result = (0, validateAndConvert_1.validateAndConvert)(params, urlParams, log);
            if (!result) {
                return;
            }
            const { options, extraParams } = result;
            const featureAppConfiguration = 
            // eslint-disable-next-line security/detect-object-injection
            featureServices['featureapp-service'].featureAppConfigurations[options.fa];
            if (!featureAppConfiguration) {
                log.fail(`fa ${params.fa} could not be found`);
                return;
            }
            (0, openLayer_1.openLayer)(options, extraParams, featureAppConfiguration, layerManager, render_1.render);
        },
    });
};
exports.registerOpenFaInLayer = registerOpenFaInLayer;
//# sourceMappingURL=registerOpenFaInLayer.js.map